import React, { Component } from 'react';
import './styles.css';
import { Tooltip } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';

class renderRemovable extends Component {
  constructor(props) {
    super(props);
    this.onRemove = this.onRemove.bind(this);
  }

  onRemove () {
    const { input, onRemove } = this.props;
    if(onRemove) {
      onRemove(input.value);
    }

    input.onChange('');
  }

  render() {
    const {
      input,
      label,
      valueText,
      disabled,
      name,
      isVisible = true,
    } = this.props;
    let inputValue = '';
    if(input.value)inputValue = input.value.toString();
    return (
      <div className='form-removable-container'>
        {
          label? <label htmlFor={name}>{label}</label>:null
        }
        <div className="value-container">
          <div className="value-label">
            {valueText || inputValue}
          </div>
          <div className='remove-btn-container'>
            {!isVisible && (
              <Tooltip title="If you close this insurer, it will no longer be selectable. The appropriate record is available under a separate entry.">
                <InfoIcon size="1rem"/>
              </Tooltip>
            )}
            {
            !disabled &&
            <div className="remove-btn linear-icon-circle-cross" onClick={this.onRemove} />
            }
          </div>
        </div>
      </div>
    );
  }
}

export default renderRemovable;
